import React, { useState, useEffect, useRef } from 'react'
import { Avatar, Box, Divider, IconButton, Button, FormControl, Typography, MenuItem, InputLabel, Drawer, TextField, Slider, Radio, RadioGroup, FormControlLabel, ToggleButtonGroup, ToggleButton, Autocomplete, Dialog, DialogContent, Stepper, Step, StepLabel, stepConnectorClasses, StepConnector, StepIconProps, FormHelperText } from "@mui/material"
import { styled } from '@mui/material/styles';
import filter from "../../../assets/Project_Images/Icons/filter.png"
import clsx from "clsx"
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import dayjs, { Dayjs } from "dayjs";
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { CancelOutlined, Info, InfoOutlined, KeyboardArrowLeft, KeyboardArrowRight, WestOutlined } from '@mui/icons-material';
import { ErrorMessage, Form, Formik, useFormik } from "formik";
import * as Yup from "yup";
import { ApiApplyBundleAllocations, ApiApplyTransportBundle, ApiDeleteInvitedAllocation, ApiGetAllocationCriteriaDetails, ApiGetNewBrief, ApiGetQuiz, APiGetTimeSelection, ApiInviteAllocation, ApiSubmitQuiz, applyTasks, getVisitTimes, } from '../../../apiService/Core/Apicall.tsx';
import { DatePicker } from '@mui/x-date-pickers';
import { useDispatch, useSelector } from 'react-redux';
import { hideLoading, showLoading } from '../../../Redux/loadingSlice.tsx';
import Loading from '../../Loader/Loading.tsx';
import { RootState } from '../../../Redux/Store.tsx';
import { findData, setData } from '../../../Redux/GetTimeSlice.tsx';
import sad from '../../../assets/Project_Images/sad (2).png'
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { clientEntity } from '../../../apiService/Core/ApiEndPoint.tsx';
import minMax from "dayjs/plugin/minMax";
import ReadBrief from './ReadBrief.tsx';
import { setSelectedMonth } from '../../../Redux/MonthSlice.tsx';

dayjs.extend(minMax);

function Invitations() {
    const [totalallocation, settotalAllocation] = useState<any>();
    const [selectedId, setSelectedId] = useState<any>(null);
    const [OpenDialog, setOpenDialog] = useState<boolean>(false);
    const [OpenBriefDialog, setOpenBriefDialog] = useState<boolean>(false);
    const [isConfirmApply, setisConfirmApply] = useState<boolean>(false);
    const navigate = useNavigate()
    // const [selectedmonth, setSelectedmonth] = useState<Dayjs>();
    const userData = JSON.parse(localStorage.getItem('userData') || '{}');
    const loading = useSelector((state: any) => state.loader.isLoading);
    const dispatch = useDispatch()
    const filtervalue = useSelector((state: RootState) => state.counter.filterData)
    const defaultMonth = useSelector((state: RootState) => state.month.selectedMonth)
    const [allocationCriteria, setAllocationCriteria] = useState<any>();
    const [isTransport, setisTransport] = useState<boolean>(false);
    const [activeStep, setActiveStep] = React.useState<any>(0);
    const [SendData, setSendData] = useState<any>([]);
    const [viewBrief, setViewBrief] = useState<any>(null)
    const [OpenNewBriefDialog, setOpenNewBriefDialog] = useState<boolean>(false);
    const [OpenNewBriefReadDialog, setOpenNewBriefReadDialog] = useState<boolean>(false);
    const [newBrief, setNewBrief] = useState<any>()
    const [QuizList, setQuizList] = useState<any[]>([])
    const [selectedOptions, setSelectedOptions] = useState<any>([]);
    const [OpenQuiz, setOpenQuiz] = useState<boolean>(false);
    const [IsQuizSubmitted, setIsQuizSubmitted] = useState<boolean>(false);
    const [quizType, setQuizType] = useState<any>()
    const [selectedmonth, setSelectedmonth] = useState<Dayjs>(dayjs(defaultMonth));
    const [openPicker, setOpenPicker] = useState(false);
    const [openInfo, setOpenInfo] = useState<boolean>(false)



    const fetchData = async () => {
        try {
            const response = await getVisitTimes();

            dispatch(setData(response.data));
        }
        catch (error: any) {
            const message =
                error?.response?.data?.message ||
                error?.message ||
                String(error);
            toast.error(message)
        }
    };

    const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
        [`&.${stepConnectorClasses.alternativeLabel}`]: {
            top: 15,
        },
        [`&.${stepConnectorClasses.active}`]: {
            [`& .${stepConnectorClasses.line}`]: {
                backgroundColor: '#BF613B', // color when active
            },
        },
        [`&.${stepConnectorClasses.completed}`]: {
            [`& .${stepConnectorClasses.line}`]: {
                backgroundColor: '#7C9FB2', // color when completed
            },
        },
        [`& .${stepConnectorClasses.line}`]: {
            height: 5,
            margin: 0,
            Padding: 0,
            border: 0,
            backgroundColor: '#ccc', // default (inactive) color
            borderRadius: 1,
        },
    }));

    const ColorlibStepIconRoot = styled('div')<{
        ownerState: { active?: boolean; completed?: boolean };
    }>(({ theme, ownerState }) => ({
        backgroundColor: ownerState.completed
            ? '#7C9FB2' // green for completed
            : ownerState.active
                ? '#BF613B' // blue for active
                : '#ccc', // grey for default
        zIndex: 1,
        color: '#fff',
        width: 32,
        height: 32,
        padding: 0,
        margin: 0,
        display: 'flex',
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center',
    }));

    function ColorlibStepIcon(props: StepIconProps) {
        const { active, completed, className, icon } = props;

        return (
            <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
                {icon}
            </ColorlibStepIconRoot>
        );
    }

    useEffect(() => {
        fetchData();
    }, [dispatch]);

    useEffect(() => {
        if (totalallocation?.data?.length > 0) {
            setSelectedId(window.innerWidth <= 576 ? null : 0);
            const locationType = totalallocation?.data?.[0]?.allocations[0]?.venueId?.locationType;
            const visitTimeArray =
                // locationType === "region"
                //     ? allocationCriteria?.regionVisitTimeInformation?.split(",").map(Number)
                //     : 
                totalallocation?.data?.[0]?.allocations[0]?.visitTimeInformation?.split(",").map(Number);
            totalallocation?.data?.[0]?.bundleId ? setisTransport(totalallocation?.data?.[0]?.allocations[0]?.allocationClientGroup === "TRANSPORT") : setisTransport(undefined)
            if (!totalallocation.data[0].bundleId) {
                // dispatch(findData(totalallocation.data[0].allocations[0].visitTimeInformation.split(',').map(Number)));
                dispatch(findData(visitTimeArray));
            }

        }
    }, [totalallocation]);

    useEffect(() => {
        if (totalallocation?.data?.[selectedId]?.isNeedToSelectDate || !isTransport) {
            dispatch(
                findData(
                    totalallocation?.data?.[selectedId]?.allocations[activeStep]?.visitTimeInformation
                        ?.split(",")
                        .map(Number)
                )
            )
        } else {
            dispatch(
                findData(
                    totalallocation?.data?.[selectedId]?.bundleVisitTimeInformation
                        ?.split(",")
                        .map(Number)
                )
            )
        }
        (totalallocation?.data?.[selectedId]?.isNeedToSelectDate || !isTransport) && fetchAllocationCriteria(totalallocation?.data?.[selectedId]?.allocations[activeStep]);

    }, [activeStep, selectedId])

    // useEffect(() => {
    //     if (totalallocation?.data?.[selectedId]?.bundleId)
    //         setSendData([])
    //     setActiveStep(0)

    // }, [selectedId])
    // console.log("Is Transport BUndle------->", isTransport)
    // console.log("Is Criteria Required------->", totalallocation?.data?.[selectedId]?.isNeedToSelectDate)
    const selectcard = (index: number) => {
        setSelectedId(index);
        setActiveStep(0)
        const isTransportBundle = totalallocation?.data?.[index || 0]?.allocations[0]?.allocationClientGroup === "TRANSPORT"
        totalallocation?.data?.[index || 0]?.bundleId ? setisTransport(isTransportBundle) : setisTransport(undefined)
        if (!totalallocation?.data?.[index || 0]?.bundleId) {
            setSendData([])
            // setSelectedmonth(totalallocation?.data?.[index || 0]?.allocations[0]?.jobMonth)
            const month = totalallocation?.data?.[index || 0]?.allocations[activeStep || 0]?.jobMonth;
            dispatch(setSelectedMonth(new Date(new Date().getFullYear(), month - 1, 1).toISOString()))
            fetchAllocationCriteria(totalallocation?.data?.[index || 0]?.allocations[0]);
            const locationType = totalallocation?.data?.[index || 0]?.allocations[0]?.venueId?.locationType;
            const visitTimeArray =
                // locationType === "region"
                //     ? allocationCriteria?.regionVisitTimeInformation?.split(",").map(Number)
                //     : 
                totalallocation?.data?.[index || 0]?.allocations[0]?.visitTimeInformation?.split(",").map(Number);
            // dispatch(findData(totalallocation?.data[index || 0].allocations[0].visitTimeInformation.split(',').map(Number)));
            dispatch(findData(visitTimeArray));
        }
        else {
            if (totalallocation?.data?.[index]?.isNeedToSelectDate || !isTransportBundle) {
                // setSelectedmonth(totalallocation?.data?.[index]?.allocations[activeStep]?.jobMonth)
                const month = totalallocation?.data?.[index]?.allocations[activeStep]?.jobMonth;
                dispatch(setSelectedMonth(new Date(new Date().getFullYear(), month - 1, 1).toISOString()))

                const locationType = totalallocation?.data?.[index]?.allocations[activeStep]?.venueId?.locationType;
                const visitTimeArray =
                    // locationType === "region"
                    //     ? allocationCriteria?.regionVisitTimeInformation?.split(",").map(Number)
                    //     : 
                    totalallocation?.data?.[index]?.allocations[activeStep]?.visitTimeInformation?.split(",").map(Number);
                // dispatch(
                //     findData(
                //         totalallocation[index]?.allocations[activeStep]?.visitTimeInformation
                //             ?.split(",")
                //             .map(Number)
                //     )
                // )
                dispatch(
                    findData(
                        visitTimeArray
                    )
                )

            } else {
                // setSelectedmonth(totalallocation?.data?.[index]?.allocations[activeStep]?.jobMonth)
                const month = totalallocation?.data?.[index]?.allocations[activeStep]?.jobMonth;
                dispatch(setSelectedMonth(new Date(new Date().getFullYear(), month - 1, 1).toISOString()))
                const locationType = totalallocation?.data?.[index]?.allocations[activeStep]?.venueId?.locationType;
                const visitTimeArray =
                    // locationType === "region"
                    //     ? allocationCriteria?.regionVisitTimeInformation?.split(",").map(Number)
                    //     : 
                    totalallocation?.data?.[index]?.allocations[activeStep]?.visitTimeInformation?.split(",").map(Number);
                // dispatch(
                //     findData(
                //         totalallocation[index]?.bundleVisitTimeInformation
                //             ?.split(",")
                //             .map(Number)
                //     )
                // )
                dispatch(
                    findData(
                        visitTimeArray
                    )
                )
            }
            (totalallocation?.data?.[index]?.isNeedToSelectDate || !isTransportBundle) && fetchAllocationCriteria(totalallocation?.data?.[index]?.allocations[activeStep])
        }
        // console.log("filteredTime", filtervalue);
    };

    const handleDialogOpen = () => {
        setOpenDialog(true);
    };

    const handleDialogClose = () => {
        setOpenDialog(false);
        setViewBrief(null)
    };
    const handleBriefDialogOpen = () => {
        setOpenBriefDialog(true);
    };

    const handleBriefDialogClose = () => {
        setOpenBriefDialog(false);
    };

    const fetchinvitations = async () => {
        const data = `?offset=0&limit=300&userId=${userData?.userId}&month=${selectedmonth?.month() + 1}&year=${selectedmonth?.year()}`
        const res = await ApiInviteAllocation(data)
        // setAllocation(res)
        const sortedData = {
            ...res,
            data: res.data.sort((a: any, b: any) => a.month - b.month)
        };
        settotalAllocation(sortedData);
        settotalAllocation(res)
        !res?.data?.[0]?.bundleId && fetchAllocationCriteria(res?.data?.[0]?.allocations[0]);

    }
    useEffect(() => {
        fetchinvitations()
    }, [selectedmonth])


    useEffect(() => {
        if (!userData?.userId) return;
        fetchinvitations();
    }, [userData?.userId]);// Remove userData?.userId from dependencies

    useEffect(() => {
        setSelectedmonth(dayjs(defaultMonth))
    }, [defaultMonth])

    const fetchAllocationCriteria = async (item: any) => {
        if (!item?.allocationId || (!item?.venueId?.clientEntityId?.clientEntityId && !item?.clientEntityId?.clientEntityId)) { console.log("'Error while creating criteria"); return }
        const data = `?allocationId=${item?.allocationId}&clientEntityId=${item?.venueId?.clientEntityId?.clientEntityId ?? item?.clientEntityId?.clientEntityId}&userId=${userData?.userId}`;
        try {
            const response = item?.allocationId && (item?.venueId?.clientEntityId?.clientEntityId || item?.clientEntityId?.clientEntityId) && userData?.userId && await ApiGetAllocationCriteriaDetails(data);
            setAllocationCriteria(response?.data);

        } catch (error: any) {
            console.log(error?.message)
        }
    };
    // const shouldDisableDate = (date: Dayjs, activeMonth: any, activeYear: any, startDay: any, endDay: any, visitDaysString: any) => {
    //     // Convert visitDaysInformation to an array

    //     const allowedDays = visitDaysString.split(",").map(day => day.trim());

    //     // Get full day name (e.g., "Monday")
    //     const dayName = date.format("dddd");


    //     // Disable if the day is NOT in the allowedDays array
    //     if (!allowedDays.includes(dayName)) {
    //         return true;
    //     }

    //     // Disable dates outside the active month and year
    //     if (date.month() + 1 !== activeMonth || date.year() !== activeYear) {
    //         return true;
    //     }

    //     // Disable dates outside the given range
    //     if (date.date() < startDay || date.date() > endDay) {
    //         return true;
    //     }

    // };

    const shouldDisableDate = (
        date: Dayjs,
        activeMonth: any,
        activeYear: any,
        startDay: any,
        endDay: any,
        visitDaysString: string
    ) => {
        // Convert visitDaysInformation to an array
        const allowedDays = visitDaysString?.split(", ").map((day) => day?.trim());

        const formattedDate = date.format("YYYY-MM-DD");

        if (allocationCriteria?.holidayDates?.includes(formattedDate)) {
            return true;
        }

        if (
            allocationCriteria?.businessHolidays?.some(
                (holiday: any) => holiday?.date === formattedDate
            )
        ) {
            return true;
        }

        // Get full day name (e.g., "Monday")
        const dayName = date.format("dddd");

        // Disable if the day is NOT in the allowedDays array
        if (!allowedDays?.includes(dayName)) {
            return true;
        }

        // Disable dates outside the active month and year
        if (date.month() + 1 !== activeMonth || date.year() !== activeYear) {
            return true;
        }

        // Disable dates outside the given range
        if (date.date() < startDay || date.date() > endDay) {
            return true;
        }
        // Hide non-weekend days 
        if (allocationCriteria?.isNeedToHideNonWeekend) {
            const weekendDays = ["Saturday", "Sunday"];
            if (!weekendDays.includes(dayName)) {
                return true; // Disable Monday to Friday
            }
        }
        // Hide weekend days 
        if (allocationCriteria?.isNeedToHideWeekend) {
            const weekendDays = ["Saturday", "Sunday"];
            if (weekendDays.includes(dayName)) {
                return true; // Disable Monday to Friday
            }
        }
        // 6. New Condition ➡️ Block same weekday as lastJobVisitedDate
        if (
            allocationCriteria?.shouldBeDifferentDayFromPreviousMonth &&
            allocationCriteria?.lastJobVisitedDate
        ) {
            const lastVisitedDayName = dayjs(
                allocationCriteria.lastJobVisitedDate
            ).format("dddd"); // Get day name from last visited date
            if (dayName === lastVisitedDayName) {
                return true; // Block this date
            }
        }

        // New Condition ➡️ Block dates if less than minDaysGapBetweenJobs
        // if (
        //     allocationCriteria?.minDaysGapBetweenJobs &&
        //     allocationCriteria?.lastJobVisitedDate
        // ) {
        //     const gapRequired = allocationCriteria.minDaysGapBetweenJobs;
        //     const lastVisitDate = dayjs(allocationCriteria.lastJobVisitedDate);
        //     const minAllowedDate = lastVisitDate.add(gapRequired, "day"); // Add required gap

        //     if (date.isBefore(minAllowedDate, "day")) {
        //         return true; // Block dates before (lastVisitDate + gap days)
        //     }
        // }

        // New Condition ➡️ Block dates if less than minDaysGapBetweenJobs
        if (allocationCriteria?.minDaysGapBetweenJobs) {
            const gapRequired = allocationCriteria.minDaysGapBetweenJobs;

            if (
                allocationCriteria?.currentMonthVisitedDates &&
                allocationCriteria.currentMonthVisitedDates.length > 0
            ) {
                const visitedDates = allocationCriteria.currentMonthVisitedDates;

                for (let visit of visitedDates) {
                    const visitDate = dayjs(visit);

                    const startBlockedDate = visitDate.subtract(gapRequired, "day");
                    const endBlockedDate = visitDate.add(gapRequired, "day");

                    if (
                        (date.isAfter(startBlockedDate, "day") &&
                            date.isBefore(endBlockedDate, "day")) ||
                        date.isSame(startBlockedDate, "day") ||
                        date.isSame(endBlockedDate, "day") ||
                        date.isSame(visitDate, "day") // include exact visit date
                    ) {
                        return true;
                    }
                }
            }

            // 🔹 2. Else fallback to single date
            else if (allocationCriteria?.lastJobVisitedDate) {
                const lastVisitDate = dayjs(allocationCriteria.lastJobVisitedDate);

                const startBlockedDate = lastVisitDate.subtract(gapRequired, "day");
                const endBlockedDate = lastVisitDate.add(gapRequired, "day");

                if (
                    (date.isAfter(startBlockedDate, "day") &&
                        date.isBefore(endBlockedDate, "day")) ||
                    date.isSame(startBlockedDate, "day") ||
                    date.isSame(endBlockedDate, "day") ||
                    date.isSame(lastVisitDate, "day")
                ) {
                    return true;
                }
            }
        }

        // 🔹 Block dates between venueOpenMinus7Days and venueClosePlus3Days
        if (
            allocationCriteria?.venueOpenMinus7Days &&
            allocationCriteria?.venueClosePlus3Days
        ) {
            const date1 = dayjs(allocationCriteria.venueOpenMinus7Days);
            const date2 = dayjs(allocationCriteria.venueClosePlus3Days);

            if (!date1.isValid() || !date2.isValid()) {
                console.log("Invalid date");
                return false;
            }

            const start = date1.isBefore(date2) ? date1 : date2;
            const end = date1.isBefore(date2) ? date2 : date1;

            if (
                (date.isAfter(start, "day") && date.isBefore(end, "day")) ||
                date.isSame(start, "day") ||
                date.isSame(end, "day")
            ) {
                return true;
            }
        }
    };

    const deleteinvtedallocation = async (allocationId: any) => {
        const isdelete = window.confirm("Are you want to reject this task.")
        if (isdelete) {
            try {
                const data = `?invitedAllocationId=${allocationId}`
                const res = await ApiDeleteInvitedAllocation(data)
                if (res.status) {
                    fetchinvitations()
                }
            } catch (error: any) {
                const message =
                    error?.response?.data?.message || // API error message
                    error?.message ||                 // JS error message
                    String(error);
                toast.error(message)
            }
        }
    }

    const steps = selectedId !== null ? (totalallocation?.data?.[selectedId]?.isNeedToSelectDate == true || !isTransport) ? totalallocation?.data?.[selectedId]?.allocations.map((allocation: any) => `${allocation?.venueId?.venueName}`) : [1] : [];

    const initialValues = {
        allocationId: null,
        selectedVisitDate: "",
        selectedVisitTime: "",
        createdBy: userData.userId,
        bundleId: (totalallocation && selectedId) && totalallocation?.data?.[selectedId]?.bundleId,

    }
    const validationSchema = Yup.object({
        selectedVisitDate: Yup.string().required("Select a Date"),
        selectedVisitTime: Yup.string().required("Select a Time"),
    });

    const onSubmit = async (values: any, { resetForm }: any) => {
        if (totalallocation?.data?.[selectedId]?.isNeedToSelectDate || !isTransport) {

            if (!IsQuizSubmitted && allocationCriteria && allocationCriteria?.isQuizRequired) {
                await handleOpenQuiz(totalallocation?.data?.[selectedId]?.allocations[activeStep]?.clientEntityId?.clientEntityId, totalallocation?.data?.[selectedId]?.allocations[activeStep]?.venueId?.venueId)
                return;
            }

            const formattedValues = {
                ...values,
                bundleId: totalallocation?.data?.[selectedId]?.bundleId,
                allocationId:
                    totalallocation?.data?.[selectedId]?.allocations[activeStep]?.allocationId,
                selectedVisitDate: values.selectedVisitDate
                    ? dayjs(values.selectedVisitDate).format("YYYY-MM-DD")
                    : "",
            };
            const final_data = SendData
            const nextstep = activeStep + 1;
            setisConfirmApply(false)
            setActiveStep(nextstep);
            // console.log("Send Data", nextstep);
            const matchdata = final_data.findIndex((item: any) => item.allocationId == formattedValues.allocationId)
            // console.log("Match data", matchdata)

            if (matchdata != -1) {
                final_data[matchdata] = formattedValues
            }
            else {
                final_data.push(formattedValues)
            }
            // console.log("Formated Values", formattedValues);
            // console.log("Final Values", final_data);
            setSendData(final_data)
            if (final_data.length === totalallocation?.data?.[selectedId]?.allocations.length) {

                const data = {
                    appliedAllocationJob: final_data
                }
                const data2 = {
                    type: "manuallySelect",
                    withoutVenueBundleAllocationId: totalallocation?.data?.[selectedId]?.bundleId,
                    createdBy: userData?.userId,
                    allocations: final_data.map((item: any) => ({
                        allocationId: item.allocationId,
                        selectedVisitDate: item.selectedVisitDate,
                        selectedVisitTime: item.selectedVisitTime
                    }))
                }
                try {
                    const res = isTransport ? await ApiApplyTransportBundle(data2) : await ApiApplyBundleAllocations(data)
                    toast.success(res.message)
                    fetchinvitations()

                } catch (error: any) {
                    toast.error(error?.message)
                }
            }

            resetForm()

            final_data.map((item: any) => {
                if (item.allocationId == totalallocation?.data?.[selectedId]?.allocations[nextstep]?.allocationId) {
                    formik.setFieldValue('selectedVisitDate', item.selectedVisitDate)
                    formik.setFieldValue('selectedVisitTime', item.selectedVisitTime)
                }

            })

        }
        else {
            const applytransportbundle = async () => {
                try {
                    const data = {
                        "withoutVenueBundleAllocationId": totalallocation?.data?.[selectedId]?.bundleId,
                        "selectedVisitDate": values?.selectedVisitDate,
                        "selectedVisitTime": values?.selectedVisitTime,
                        "createdBy": values?.createdBy
                    }
                    console.log("APi Transport BUndle Data--------->", data)
                    // const res = await ApiApplyTransportBundle(data)
                    // if (res.status) {
                    //     fetchinvitations()
                    //     toast.success('You have successfully applied. Hold tight to find out if you are successful.')
                    // }
                } catch (error: any) {
                    const message =
                        error?.response?.data?.message || // API error message
                        error?.message ||                 // JS error message
                        String(error);
                    toast.error(message)
                }
            }
            applytransportbundle()
        }
    }


    const formik = useFormik({
        initialValues,
        validationSchema,
        validateOnChange: true, // Ensures validation only happens on blur or submit
        validateOnBlur: false,
        onSubmit,
    });

    const handleBack = (currentStep: number) => {
        const backstep = currentStep - 1;
        setActiveStep(false)
        setActiveStep((prevActiveStep: any) => prevActiveStep - 1);
        SendData.map((item: any) => {
            if (item.allocationId == totalallocation?.data?.[selectedId]?.allocations[backstep]?.allocationId) {
                formik.setFieldValue('selectedVisitDate', item?.selectedVisitDate)
                formik.setFieldValue('selectedVisitTime', item?.selectedVisitTime)
            }
        })
    };


    const handleCallAnotherCriteria = async (item: any, isNeedToHideWeekend: boolean, isNeedToHideNonWeekend: boolean) => {
        try {
            const data = `?allocationId=${item.allocationId}&venueId=${item?.venueId}&jobMonth=${item?.jobMonth}&jobYear=${item?.jobYear}&isWeekDayJob=${isNeedToHideWeekend}&isWeekendDayJob=${isNeedToHideNonWeekend}`
            const res = await APiGetTimeSelection(data)
            if (res?.status) {

                setTimeout(() => {
                    dispatch(
                        findData(
                            res?.visitTimeList?.map(Number)
                        )
                    );
                }, 100);
                // setDateCriteria(res?.data)
            }
        } catch (error) {
            const message =
                error?.response?.data?.message ||
                error?.message ||
                String(error);
            console.log(message)
        }
    }


    const getBrief = async (venueId: string, clientEntity: string) => {
        try {
            const data = `?venueId=${venueId}&clientEntityId=${clientEntity}`
            const res = await ApiGetNewBrief(data)
            if (res?.status || res?.success) {
                setNewBrief(res)
                return res;
            }
        } catch (error: any) {
            toast.error(error?.message || "Something went wrong")
        }
    }

    const handleReadBrief = async (venueId: any, clientEntityId: any) => {
        try {
            const res = await getBrief(
                venueId,
                clientEntityId)
            setNewBrief(res)
            if (allocationCriteria?.isNewBriefSetup) {
                setOpenNewBriefReadDialog(true)
            }
            else {
                handleDialogOpen();
            }
        } catch (error) {
            console.log("Error", error)
        }
    }

    const shuffleArray = (array: any) => {
        const shuffled = [...array];
        for (let i = shuffled.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
        }
        return shuffled;
    };

    const handleOpenQuiz = async (clientEntityId: string, venueId: string, isOpen: boolean = false) => {
        const data = `?clientEntityId=${clientEntityId}&venueId=${venueId}`
        const response = await ApiGetQuiz(data)
        // setQuizList(response.data)
        setQuizType(response?.quizType)
        setQuizList(shuffleArray(response.data))
        // allocationCriteria && allocationCriteria?.isQuizRequired ? setOpenBriefDialog(true) : toast.success("Quiz is not required")
        if (allocationCriteria && allocationCriteria?.isQuizRequired) {
            if (allocationCriteria?.isNewBriefSetup) {
                isOpen ? setOpenInfo(true) : setOpenNewBriefDialog(true)
                setOpenQuiz(false)
            }
            else {
                setOpenQuiz(true)
                setOpenNewBriefDialog(false)
            }
        }
        else {
            if (allocationCriteria?.isNewBriefSetup) {
                setOpenDialog(false)
                setOpenNewBriefDialog(true)
                setOpenInfo(true)
            }
            else {
                setOpenDialog(true)
                setOpenNewBriefDialog(false)
            }
        }
        setSelectedOptions([])
    }

    useEffect(() => {
        setSelectedOptions([])
        const newOptions = QuizList.map((item) => ({
            QuestionId: item.quiz_question_id,
            SelectedAnswer: null,
            answerIds: item.answerIds || ""
        }));
        setSelectedOptions((prevOptions: any) => [...prevOptions, ...newOptions]);
    }, [QuizList])

    const handlePrevMonth = () => {
        const newMonth = dayjs(defaultMonth).subtract(1, "month").toISOString();
        dispatch(setSelectedMonth(newMonth));
    };

    const handleNextMonth = () => {
        const newMonth = dayjs(defaultMonth).add(1, "month").toISOString();
        dispatch(setSelectedMonth(newMonth))
    };
    return (
        <Box height='100%' width='100%'>
            <Box gap={2} className="d-block d-none d-lg-flex mt-3 mt-md-0 ms-auto justify-content-end  align-items-center">
                <Box className="col-12">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Box
                            display="flex"
                            alignItems="center"
                            className="col-11 d-flex align-items-center justify-content-end"
                        >
                            {/* Previous Month Button */}
                            <IconButton
                                onClick={handlePrevMonth}
                                className="d-none d-md-block"
                            >
                                <KeyboardArrowLeft />
                            </IconButton>

                            {/* Month & Year Selector */}
                            <DatePicker
                                className=""
                                views={["month", 'year']}
                                value={selectedmonth}
                                onChange={(date) => { date && dispatch(setSelectedMonth(date.toISOString())); }}
                                renderInput={(params) => (
                                    <TextField {...params} variant="standard" />
                                )}
                                open={openPicker}
                                onOpen={() => setOpenPicker(true)}
                                onClose={() => setOpenPicker(false)}

                                sx={{
                                    // "@media (max-width: 600px)": {
                                    //   input: { display: "none" }, // Hide input on extra-small screens
                                    // },

                                    "& .MuiOutlinedInput-notchedOutline": {
                                        border: "none",
                                        maxWidth: "70%",
                                    },
                                    "& .MuiOutlinedInput-input": {
                                        maxWidth: "90%",
                                    },
                                    "& .MuiIconButton-root": {
                                        margin: "0px",
                                        padding: "0px",
                                        color: "#7C9FB2",
                                    },
                                    "& .MuiSvgIcon-root": {
                                        fontSize: { xs: "32px", md: "20px" },
                                    },

                                    "& .MuiOutlinedInput-root": {
                                        margin: "0px",
                                        paddingLeft: "0px",
                                        // maxWidth:'190px !important'
                                    },
                                }}
                            />

                            <IconButton
                                onClick={handleNextMonth}
                                className="d-none d-md-block"
                            >
                                <KeyboardArrowRight />
                            </IconButton>
                        </Box>
                    </LocalizationProvider>
                </Box>
            </Box>
            {totalallocation?.data?.length > 0 ? (
                <Box className='d-flex flex-column flex-lg-row' minHeight={{ md: 'calc(100vh - 65px)' }} height={'fit-content'}>
                    <Box className='col-lg-4 col-12 p-4 pt-0 pe-lg-0  p-lg-3' display={{ xs: selectedId !== null ? 'none' : 'block', sm: 'block' }} height='fit-contnet'>

                        {/* ------------------------------------------------------------------------------------- Tasks ------------------------------------------------------------- */}
                        <Box className=' mt-4 h-100' maxHeight='calc( 100vh - 130px)' overflow='auto' >

                            {totalallocation.data.map((card: any, index: number) => {
                                const currentDate = dayjs(`${card.year}-${card.month}-01`).format("MMM YYYY");

                                const prevDate =
                                    index > 0
                                        ? dayjs(`${totalallocation.data[index - 1].year}-${totalallocation.data[index - 1].month}-01`).format("MMM YYYY")
                                        : null;

                                const showDateHeader = currentDate !== prevDate;

                                return (
                                    <React.Fragment key={index}>
                                        {/* ✅ Date Header */}
                                        {/* {showDateHeader && (
                                            <Box position="sticky" top={0} bgcolor="white" zIndex={1}>
                                                <Typography
                                                    width="fit-content"
                                                    className="fs-16 custom-bg mb-2 border-10 fw-bolder text-light px-3 py-1"
                                                >
                                                    {currentDate}
                                                </Typography>
                                                <hr className="m-0 mb-2" />
                                            </Box>
                                        )} */}

                                        {/* ✅ Normal Card */}
                                        {!card?.bundleId ? (
                                            <Box
                                                className={clsx("task mb-3", { "bg-alternate": selectedId === index })}
                                                border={selectedId === index ? "" : "1px solid #ccc"}
                                                onClick={() => selectcard(index)}
                                            >
                                                <Box className="d-flex gap-2 align-items-center">
                                                    <Avatar
                                                        src={card?.allocations[0]?.venueId?.logoUrl}
                                                        sx={{ height: "42px", width: "42px" }}
                                                    />
                                                    <Box>
                                                        <Typography variant="subtitle1" fontWeight="bold">
                                                            {card?.allocations[0]?.venueId?.venueName}
                                                            {card?.differentiateKey ? ` (${card?.differentiateKey})` : ""}
                                                        </Typography>
                                                        <Typography variant="caption" className="task-caption">
                                                            {card?.allocations[0]?.allocationPriceDisplay || "N/A"}
                                                        </Typography>
                                                    </Box>
                                                </Box>

                                                <Box>
                                                    <Typography variant="body2" className="text-end">
                                                        {card?.allocations[0].distanceInKm}
                                                        {card?.allocations[0].distanceInKm ? "km" : ""}
                                                    </Typography>
                                                    <Typography
                                                        variant="caption"
                                                        className="px-3 py-1 bg-second text-white"
                                                        borderRadius="8px"
                                                    >
                                                        {card.allocations[0].clientEntityId?.entityTypeId?.entityTypeName}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        ) : (
                                            /* ✅ Bundle Card */
                                            <Box
                                                className="border mb-3 task-main2"
                                                bgcolor={selectedId === index ? "#E3DDD1" : ""}
                                                borderRadius="20px"
                                                onClick={() => selectcard(index)}
                                                sx={{ cursor: "pointer" }}
                                            >
                                                <Typography className="fw-bold px-3 pt-2 pb-1" borderBottom="1px solid #ccc">
                                                    {card.bundleName}-{index + 1}
                                                </Typography>

                                                <Box className="p-3">
                                                    {card?.allocations.map((item: any, index2: number) => (
                                                        <Box
                                                            key={index2}
                                                            className="task-2 task-3 mb-3 flex-wrap"
                                                            bgcolor={selectedId === index ? "#FFFFFF" : ""}
                                                            border={
                                                                selectedId === index
                                                                    ? "1px solid #ADB792"
                                                                    : "1px solid #a3a3a3"
                                                            }
                                                        >
                                                            <Box className="d-flex gap-2 align-items-center">
                                                                <Avatar
                                                                    src={item?.venueId?.logoUrl}
                                                                    sx={{
                                                                        height: "40px",
                                                                        width: "42px",
                                                                        img: { objectFit: "contain" },
                                                                    }}
                                                                />

                                                                <Box>
                                                                    <Box className='d-flex align-items-center'>
                                                                        <Typography variant="subtitle1" fontWeight="bold">
                                                                            {item.venueId?.venueName ??
                                                                                `${item?.clientEntityId?.entityName} - ${item?.differentiateKey}`}
                                                                        </Typography>
                                                                        <IconButton title='View Detail' onClick={(e) => { e.stopPropagation(); setViewBrief(item?.venueId?.venueDescription); handleReadBrief(item?.venueId?.venueId, item?.clientEntityId?.clientEntityId) }} ><Info sx={{ fontSize: '18px', fill: "#ADB792 !important" }} /></IconButton>
                                                                    </Box>
                                                                    <Typography variant="caption" className="task-caption">
                                                                        {item?.allocationPriceDisplay || "N/A"}
                                                                    </Typography>
                                                                </Box>
                                                            </Box>

                                                            <Box>
                                                                <Typography variant="body2" className="text-end">
                                                                    {item?.distanceInKm &&
                                                                        parseFloat(item.distanceInKm).toFixed(2)}
                                                                    {item?.distanceInKm ? "km" : ""}
                                                                </Typography>

                                                                <Typography
                                                                    variant="caption"
                                                                    className="px-3 bg-second py-1 text-white"
                                                                    borderRadius="8px"
                                                                >
                                                                    {item.venueId?.clientEntityId?.entityTypeId?.entityTypeName ??
                                                                        item?.clientEntityId?.entityName}
                                                                </Typography>
                                                            </Box>

                                                            <Box className="d-flex col-12 mt-1 align-items-center justify-content-between">
                                                                <Typography fontSize="12px">
                                                                    {item?.allocationClientGroup}
                                                                </Typography>
                                                                <Typography fontSize="12px">
                                                                    Postcode:{" "}
                                                                    {item?.venueId?.postalCode ??
                                                                        item?.clientEntityId?.postalCode}
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                    ))}
                                                </Box>
                                            </Box>
                                        )}
                                    </React.Fragment>
                                );
                            })}
                        </Box>

                    </Box>
                    <Box className='col-lg-8 col-12 p-3'>
                        {selectedId !== null && totalallocation?.data[selectedId] &&

                            !totalallocation?.data[selectedId]?.bundleId ?
                            (
                                <>
                                    <Box className='h-100 d-flex flex-md-row flex-column' border={{ xs: 'none', sm: '1px solid #a3a3a3' }} borderRadius='10px'>
                                        <IconButton className='w-100 justify-content-start d-flex d-md-none' onClick={() => { setSelectedId(null) }}>
                                            <WestOutlined fontSize='medium' />
                                        </IconButton>
                                        <Box className='col-md-6 col-xl-7 col-12 p-3'>
                                            <Box className='d-flex gap-3'>
                                                <Box className='d-flex gap-2'>
                                                    <Avatar src={totalallocation.data[selectedId].allocations[0]?.venueId?.logoUrl} sx={{ height: '42px', width: '42px' }}></Avatar>
                                                    <Box>
                                                        <Typography variant='subtitle1' fontWeight='bold' className='m-0 p-0'>{totalallocation.data[selectedId].allocations[0].venueId?.venueName}</Typography>
                                                        <Typography variant='caption' className='px-3 py-1 bg-second text-white' borderRadius='8px'>{totalallocation.data[selectedId].allocations[0].clientEntityId?.entityTypeId?.entityTypeName}</Typography>
                                                    </Box>
                                                </Box>
                                                <Typography variant='subtitle1' className='text-main'>{totalallocation.data[selectedId].allocations[0]?.allocationPriceDisplay !== '' ? totalallocation.data[selectedId].allocations[0]?.allocationPriceDisplay : "N/A"}</Typography>
                                            </Box>
                                            <Box className='my-2'>
                                                <Typography variant='subtitle2' className='text-grey'>Address</Typography>
                                                <Typography variant='subtitle1' fontWeight='bold' >{totalallocation.data[selectedId].allocations[0].venueId?.address} {totalallocation.data[selectedId].allocations[0].venueId?.city} {totalallocation.data[selectedId].allocations[0].venueId?.state} {totalallocation.data[selectedId].allocations[0].venueId?.postalCode}</Typography>
                                            </Box>
                                            <Box className='my-2'>
                                                <Typography variant='subtitle2' className='text-grey'>PostCode</Typography>
                                                <Typography variant='subtitle1' fontWeight='bold' >{totalallocation.data[selectedId].allocations[0].venueId?.postalCode}</Typography>
                                            </Box>
                                            {totalallocation.data[selectedId].allocations[0].clientEntityId?.entityTypeId?.entityTypeName !== "Liquor ID" && (
                                                <Box className='my-2'>
                                                    <Typography variant='subtitle2' className='text-grey'>Trading Hours</Typography>
                                                    <Typography variant='subtitle1' fontWeight='bold' >{totalallocation.data[selectedId].allocations[0].venueId?.tradingHours}</Typography>
                                                </Box>
                                            )}
                                            <Box className='my-2'>
                                                <Typography variant='subtitle2' className='text-grey'>Website</Typography>
                                                <Typography variant='subtitle1' fontWeight='bold' ><a target="__blank" href={totalallocation.data[selectedId].allocations[0].venueId?.websiteURL}>{totalallocation.data[selectedId].allocations[0].venueId?.websiteURL}</a></Typography>
                                            </Box>
                                            <Box className='my-2'>
                                                <Typography variant='caption' className='text-grey'>Special Comments</Typography>
                                                <Typography variant='subtitle1' fontWeight='bold' >
                                                    {totalallocation.data[selectedId].allocations[0].specialComment}
                                                </Typography>
                                            </Box>
                                            <Box className='my-2'>
                                                <Button fullWidth variant='outlined' className='button-secondary-outlined mt-3' onClick={() => { handleReadBrief(totalallocation.data[selectedId].allocations[0]?.venueId?.venueId, totalallocation?.data[selectedId]?.allocations[0]?.clientEntityId?.clientEntityId) }}>Read Brief</Button>
                                            </Box>

                                        </Box>
                                        {/* {window.innerWidth > 767 && ( */}
                                        <Divider orientation="vertical" sx={{ display: { xs: 'none', sm: 'block' }, borderColor: "#a3a3a3" }} />
                                        {/* )} */}
                                        <Formik className='w-100 col-md-6 col-xl-5'
                                            initialValues={{
                                                allocationId: null,
                                                selectedVisitDate: '',
                                                selectedVisitTime: '',
                                                createdBy: userData.userId,
                                            }}

                                            validationSchema={Yup.object({
                                                selectedVisitDate: Yup.string().required("Select a Date"),
                                                selectedVisitTime: Yup.string().required("Select a TIme"),

                                            })}

                                            onSubmit={async (values) => {

                                                if (!IsQuizSubmitted && allocationCriteria && allocationCriteria?.isQuizRequired) {
                                                    await handleOpenQuiz(totalallocation.data[selectedId].allocations[0]?.clientEntityId?.clientEntityId, totalallocation.data[selectedId].allocations[0]?.venueId?.venueId)
                                                    return;
                                                }
                                                if (IsQuizSubmitted && allocationCriteria?.isQuizRequired) {
                                                    const data = {
                                                        userId: userData?.userId,
                                                        type: quizType,
                                                        ...(quizType === "venue"
                                                            ? {
                                                                venueId: totalallocation.data[selectedId].allocations[0]?.venueId?.venueId,
                                                            }
                                                            : {
                                                                clientEntityId:
                                                                    totalallocation.data[selectedId].allocations[0]?.clientEntityId?.clientEntityId,
                                                            }),
                                                    }
                                                    await ApiSubmitQuiz(data)
                                                }
                                                const formattedValues = {
                                                    ...values,
                                                    allocationId: totalallocation.data[selectedId].allocations[0].allocationId,
                                                    selectedVisitDate: values.selectedVisitDate
                                                        ? dayjs(values.selectedVisitDate).format("YYYY-MM-DD")
                                                        : "",
                                                };


                                                try {
                                                    const response = await applyTasks(formattedValues)

                                                    toast.success('You have successfully applied. Hold tight to find out if you are successful.')
                                                    navigate('/dashboard/mytasks')
                                                }
                                                catch (error: any) {
                                                    toast.error(error?.message)
                                                }
                                                finally {

                                                }
                                            }
                                            }
                                        >
                                            {(formik) => {
                                                const allocation = totalallocation.data[selectedId].allocations[0];

                                                const monthStart = dayjs(
                                                    `${allocation.jobYear}-${allocation.jobMonth}-01`
                                                ).startOf("month");

                                                const monthEnd = monthStart.endOf("month");

                                                const handleApplyTaskClick = async () => {
                                                    formik.setTouched({
                                                        selectedVisitDate: true,
                                                        selectedVisitTime: true,
                                                    });

                                                    const errors = await formik.validateForm();

                                                    if (Object.keys(errors).length > 0) {
                                                        return;
                                                    }

                                                    // handleBriefDialogOpen();
                                                    allocationCriteria?.isNewBriefSetup ? setOpenInfo(true) : handleBriefDialogOpen();
                                                };
                                                return (
                                                    <Form className='w-100'>
                                                        <Box className=' w-100 d-flex flex-column col-12 p-3'>
                                                            <Box className='flex-grow-1'>
                                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                    <StaticDatePicker
                                                                        key={selectedmonth.month()}
                                                                        value={formik.values.selectedVisitDate ? dayjs(formik.values.selectedVisitDate) : null}
                                                                        onChange={(newValue) => {
                                                                            formik.setFieldValue("selectedVisitDate", newValue ? newValue.format("YYYY-MM-DD") : "");
                                                                            const data2 = {
                                                                                allocationId: totalallocation?.data?.[selectedId]?.allocations[0]?.allocationId,
                                                                                clientEntityId: totalallocation?.data?.[selectedId]?.allocations[0]?.venueId.clientEntityId?.clientEntityId,
                                                                                venueId: totalallocation?.data?.[selectedId]?.allocations[0]?.venueId.venueId,
                                                                                jobMonth: totalallocation?.data?.[selectedId]?.allocations[0]?.jobMonth,
                                                                                jobYear: totalallocation?.data?.[selectedId]?.allocations[0]?.jobYear,
                                                                                userId: userData?.userId,
                                                                            };
                                                                            newValue && allocationCriteria?.shouldBeDifferentVisitTimeFromPreviousAllocation && handleCallAnotherCriteria(data2, allocationCriteria?.isNeedToHideWeekend, allocationCriteria?.isNeedToHideNonWeekend)
                                                                        }}
                                                                        // referenceDate={dayjs(totalallocation.data[selectedId].jobMonth, "YYYY-MM")}
                                                                        referenceDate={
                                                                            selectedmonth
                                                                                ? dayjs(selectedmonth, "YYYY-MM")
                                                                                : dayjs(`${totalallocation?.data?.[selectedId]?.allocations[0]?.jobYear}-${String(totalallocation?.data?.[selectedId]?.allocations[0]?.jobMonth).padStart(2, "0")}`, "YYYY-MM")

                                                                        }
                                                                        // minDate={dayjs()}
                                                                        // minDate={monthStart}
                                                                        maxDate={monthEnd}
                                                                        shouldDisableDate=
                                                                        {(date) =>
                                                                            shouldDisableDate(
                                                                                date,
                                                                                totalallocation.data[selectedId].allocations[0].jobMonth,
                                                                                totalallocation.data[selectedId].allocations[0].jobYear,
                                                                                // allocationCriteria?.minDate,
                                                                                // allocationCriteria?.maxDate,
                                                                                // allocationCriteria?.visitDaysInformation,
                                                                                totalallocation?.data[selectedId]?.allocations[0]?.minDate,
                                                                                totalallocation?.data[selectedId]?.allocations[0]?.maxDate,
                                                                                totalallocation?.data[selectedId]?.allocations[0]?.visitDaysInformation
                                                                            )}

                                                                        sx={{
                                                                            "& .MuiPickersDay-root.Mui-selected": {
                                                                                backgroundColor: '#ADB792 !important'
                                                                            }
                                                                        }}
                                                                    />
                                                                </LocalizationProvider>
                                                                <ErrorMessage name="selectedVisitDate" component="div" className='error' />


                                                                <FormControl fullWidth>

                                                                    <InputLabel id="demo-simple-select-label" shrink={false}> <span>Visiting Time{" "}
                                                                        <sup>
                                                                            <i className="fa-solid fa-star-of-life star"></i>
                                                                        </sup>
                                                                    </span></InputLabel>
                                                                    <Select
                                                                        labelId="demo-simple-select-label"
                                                                        aria-placeholder='Select the Time'
                                                                        value={formik.values.selectedVisitTime}
                                                                        onChange={(e) => formik.setFieldValue("selectedVisitTime", e.target.value)}
                                                                        MenuProps={{
                                                                            disablePortal: false, // Ensures dropdown is rendered inside the parent DOM
                                                                        }}
                                                                    >
                                                                        {filtervalue?.map((option, index) => (
                                                                            <MenuItem key={index} value={option.visitTimeId}>
                                                                                {option.visitTimeInformation}
                                                                            </MenuItem>
                                                                        ))}

                                                                    </Select>
                                                                </FormControl>
                                                                <ErrorMessage name="selectedVisitTime" component="div" className='error' />

                                                            </Box>
                                                            <Button
                                                                fullWidth
                                                                className="button-primary mt-4"
                                                                // onClick={handleApplyTaskClick}
                                                                onClick={async () => {
                                                                    if (!formik.values.selectedVisitDate || !formik.values.selectedVisitTime) {
                                                                        await formik.setTouched({
                                                                            selectedVisitDate: true,
                                                                            selectedVisitTime: true,
                                                                        });
                                                                        toast.error('Please select both date and time')
                                                                        return
                                                                    }
                                                                    await getBrief(
                                                                        totalallocation?.data[selectedId]?.allocations[0]?.venueId?.venueId,
                                                                        totalallocation?.data[selectedId]?.allocations[0]?.clientEntityId?.clientEntityId
                                                                    );

                                                                    if (
                                                                        allocationCriteria?.isQuizRequired &&
                                                                        !allocationCriteria?.isNewBriefSetup
                                                                    ) {
                                                                        await handleOpenQuiz(
                                                                            totalallocation?.data[selectedId]?.allocations[0]?.clientEntityId?.clientEntityId,
                                                                            totalallocation?.data[selectedId]?.allocations[0]?.venueId?.venueId,
                                                                            true
                                                                        );
                                                                    } else {
                                                                        handleApplyTaskClick();
                                                                    }
                                                                }}
                                                            >
                                                                {/* Apply Task */}
                                                                {allocationCriteria?.isQuizRequired ? "Take Quiz" : "Apply Task"}
                                                            </Button>

                                                            {/* <Button type='submit' className='button-primary mt-4' fullWidth>Apply Task</Button> */}
                                                            <Button onClick={() => { deleteinvtedallocation(totalallocation?.data[selectedId]?.invitedAllocationId) }} variant='outlined' className='button-danger-outlined mt-4' fullWidth>Reject</Button>

                                                        </Box>
                                                        <Dialog disablePortal open={OpenBriefDialog}>
                                                            <DialogContent>
                                                                {selectedId !== null && totalallocation?.data[selectedId] ? (
                                                                    <>
                                                                        <IconButton
                                                                            className="ms-auto d-block"
                                                                            onClick={() => {
                                                                                handleBriefDialogClose();
                                                                            }}
                                                                        >
                                                                            <CancelOutlined className="fd-2" />
                                                                        </IconButton>
                                                                        <Box
                                                                            overflow="auto"
                                                                            dangerouslySetInnerHTML={{
                                                                                __html:
                                                                                    totalallocation.data[selectedId]?.allocations[0].venueId
                                                                                        ?.venueDescription || "",
                                                                            }}
                                                                        />
                                                                        <div className="d-flex my-2">
                                                                            <label className="d-flex align-items-center justify-content-center gap-2">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    checked={isConfirmApply}
                                                                                    onChange={(e) => { setisConfirmApply(e.target.checked) }}
                                                                                />
                                                                                <span>Read & understood</span>
                                                                            </label>
                                                                        </div>
                                                                        <Button
                                                                            disabled={!isConfirmApply}
                                                                            className="button-primary mx-auto py-2 px-4 d-block"
                                                                            onClick={() => { formik.handleSubmit() }}
                                                                            sx={{
                                                                                "&.Mui-disabled": {
                                                                                    backgroundColor: "#ccc !important",
                                                                                    color: "#666 !important",
                                                                                    cursor: "not-allowed",
                                                                                },
                                                                            }}
                                                                        >
                                                                            Apply
                                                                        </Button>
                                                                    </>
                                                                ) : (
                                                                    <Typography variant="subtitle1">No Data Found</Typography>
                                                                )}
                                                            </DialogContent>
                                                        </Dialog>

                                                        <Dialog open={OpenNewBriefDialog && !totalallocation?.data[selectedId]?.bundleId} className="full-dilaog d-flex flex-column" fullScreen>
                                                            <DialogContent className="p-0" sx={{ flex: 1 }}>
                                                                {newBrief?.data && (<ReadBrief isVewOnly={false} handleClose={() => setOpenNewBriefDialog(false)} title={newBrief?.mainTitle} newBrief={newBrief?.data} selecetedAllocation={totalallocation?.data[selectedId]?.allocations[0]} setSelectedOptions={setSelectedOptions} setIsQuizSubmitted={setIsQuizSubmitted} selectedOptions={selectedOptions} QuizList={QuizList} handleOpenQuiz={handleOpenQuiz} submitform={formik.handleSubmit} />)}
                                                            </DialogContent>
                                                        </Dialog>

                                                    </Form>
                                                )
                                            }}

                                        </Formik>
                                    </Box>
                                </>
                            ) :
                            (
                                <>

                                    <Box
                                        className="h-100 d-flex flex-md-row flex-column"
                                        border={{ xs: "none", sm: "1px solid #a3a3a3" }}
                                        width={(totalallocation?.data?.[selectedId]?.isNeedToSelectDate || !isTransport) ? '100%' : 'fit-content'}
                                        borderRadius="10px"
                                    >
                                        <IconButton
                                            className="w-100 justify-content-start d-flex d-md-none"
                                            onClick={() => {
                                                setSelectedId(null);
                                            }}
                                        >
                                            <WestOutlined fontSize="medium" />
                                        </IconButton>

                                        <Box width='100%'>
                                            <Box className='my-2'>
                                                <Stepper key={steps} connector={<ColorlibConnector />} activeStep={activeStep} alternativeLabel>
                                                    {(totalallocation?.data?.[selectedId]?.isNeedToSelectDate || !isTransport) && (steps?.map((label: any) => (
                                                        <Step key={label}>
                                                            <StepLabel StepIconComponent={ColorlibStepIcon}></StepLabel>
                                                        </Step>
                                                    )))}
                                                </Stepper>
                                            </Box>
                                            {activeStep !== steps?.length ?
                                                // (    <React.Fragment>
                                                //         <Typography sx={{ mt: 2, mb: 1 }}>
                                                //             All steps completed - you&apos;re finished
                                                //         </Typography>
                                                //         <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                                                //             <Box sx={{ flex: '1 1 auto' }} />
                                                //             <Button onClick={handleReset}>Reset</Button>
                                                //         </Box>
                                                //     </React.Fragment>
                                                // ) : 
                                                (
                                                    <React.Fragment>
                                                        <Box className='d-flex flex-column' height='calc(100% - 50px)'>
                                                            {(totalallocation?.data?.[selectedId]?.isNeedToSelectDate || !isTransport) && (
                                                                <Box width='100%' borderBottom={'1px solid #ccc'} className='p-2' sx={{ display: 'flex', flexDirection: 'row' }}>
                                                                    <Button
                                                                        className='bg-second text-light button-secondary-outlined px-4 py-1'
                                                                        color="inherit"
                                                                        disabled={activeStep === 0}
                                                                        onClick={() => { handleBack(activeStep) }}
                                                                        sx={{ mr: 1 }}
                                                                    >
                                                                        Back
                                                                    </Button>
                                                                    <Box sx={{ flex: '1 1 auto' }} />

                                                                </Box>
                                                            )}
                                                            <Box className='d-flex' flexWrap={{ xs: "wrap", lg: 'nowrap' }} flex={1} maxWidth={'100%'}>
                                                                {(totalallocation?.data?.[selectedId]?.isNeedToSelectDate || !isTransport) && (
                                                                    <Box className="col-md-6 col-xl-7 col-12 p-3 h-100">
                                                                        <Box className="d-flex gap-3">
                                                                            <Box className="d-flex gap-2">
                                                                                <Avatar
                                                                                    src={
                                                                                        totalallocation?.data?.[selectedId]?.allocations[activeStep]?.venueId?.logoUrl
                                                                                    }
                                                                                    sx={{
                                                                                        height: "40px",
                                                                                        width: "42px",
                                                                                        img: {
                                                                                            objectFit: "contain",
                                                                                        },
                                                                                    }}
                                                                                />

                                                                                <Box>
                                                                                    <Typography
                                                                                        variant="subtitle1"
                                                                                        fontWeight="bold"
                                                                                        className="m-0 p-0"
                                                                                    >
                                                                                        {
                                                                                            totalallocation?.data?.[selectedId]?.allocations[activeStep]?.venueId?.venueName ?? `${totalallocation?.data?.[selectedId]?.allocations[activeStep]?.clientEntityId?.entityName} - ${totalallocation?.data?.[selectedId]?.allocations[activeStep]?.differentiateKey}`
                                                                                        }

                                                                                    </Typography>
                                                                                    <Typography
                                                                                        variant="caption"
                                                                                        className="px-3 py-1 bg-second text-white"
                                                                                        borderRadius="8px"

                                                                                    >
                                                                                        {
                                                                                            totalallocation?.data?.[selectedId]?.allocations[activeStep]
                                                                                                ?.clientEntityId?.entityName
                                                                                        }
                                                                                    </Typography>
                                                                                </Box>
                                                                            </Box>
                                                                            <Typography variant="subtitle1" className="text-main">
                                                                                {
                                                                                    totalallocation?.data?.[selectedId]?.allocations[activeStep]?.allocationPriceDisplay !== '' ? totalallocation?.data?.[selectedId]?.allocations[activeStep]?.allocationPriceDisplay : "N/A"
                                                                                }
                                                                            </Typography>
                                                                        </Box>
                                                                        <Box className="my-2">
                                                                            <Typography variant="subtitle2" className="text-grey">
                                                                                Address
                                                                            </Typography>
                                                                            <Typography variant="subtitle1" fontWeight="bold">
                                                                                {totalallocation?.data?.[selectedId]?.allocations[activeStep]?.venueId?.address} {totalallocation?.data?.[selectedId]?.allocations[activeStep]?.venueId?.city} {totalallocation?.data?.[selectedId]?.allocations[activeStep]?.venueId?.state} n{totalallocation?.data?.[selectedId]?.allocations[activeStep]?.venueId?.postalCode}
                                                                            </Typography>
                                                                        </Box>
                                                                        <Box className="my-2">
                                                                            <Typography variant="subtitle2" className="text-grey">
                                                                                Postcode
                                                                            </Typography>
                                                                            <Typography variant="subtitle1" fontWeight="bold">
                                                                                {totalallocation?.data?.[selectedId]?.allocations[activeStep]?.venueId?.postalCode}
                                                                            </Typography>
                                                                        </Box>
                                                                        {totalallocation?.data[selectedId]?.allocations[activeStep]?.clientEntityId?.entityName != "Liquor ID" &&
                                                                            (<Box className="my-2">
                                                                                <Typography variant="caption" className="text-grey">
                                                                                    Trading Hours
                                                                                </Typography>
                                                                                <Typography variant="subtitle2" fontWeight="bold">
                                                                                    {totalallocation?.data?.[selectedId]?.allocations[activeStep]?.venueId?.tradingHours}
                                                                                </Typography>
                                                                            </Box>
                                                                            )}
                                                                        <Box className="my-2">
                                                                            <Typography variant="subtitle2" className="text-grey">
                                                                                Website
                                                                                {/* Active allocation = {totalallocation?.data?.[selectedId]?.allocations[activeStep]?.allocationId} */}
                                                                            </Typography>
                                                                            <Typography variant="subtitle1" fontWeight="bold">
                                                                                <a target="__blank" href={totalallocation?.data?.[selectedId]?.allocations[activeStep]?.venueId?.websiteURL}>{totalallocation?.data?.[selectedId]?.allocations[activeStep]?.venueId?.websiteURL}</a>
                                                                            </Typography>
                                                                        </Box>
                                                                        <Box className="my-2">
                                                                            <Typography variant="caption" className="text-grey">
                                                                                Special Comments
                                                                            </Typography>
                                                                            <Typography variant="subtitle2" fontWeight="bold">
                                                                                {totalallocation?.data?.[selectedId]?.allocations[activeStep]?.specialComment}
                                                                            </Typography>
                                                                        </Box>
                                                                        <Box className="my-2">
                                                                            <Button
                                                                                variant='outlined'
                                                                                fullWidth
                                                                                className="button-secondary-outlined mt-3"
                                                                                // onClick={handleDialogOpen}
                                                                                onClick={() => { handleReadBrief(totalallocation?.data?.[selectedId]?.allocations[activeStep]?.venueId?.venueId, totalallocation?.data?.[selectedId]?.allocations[activeStep]?.clientEntityId?.clientEntityId) }}
                                                                            >
                                                                                Read Brief
                                                                            </Button>
                                                                        </Box>
                                                                    </Box>
                                                                )}
                                                                {window.innerWidth > 767 && (totalallocation?.data?.[selectedId]?.isNeedToSelectDate || !isTransport) && (
                                                                    <Divider
                                                                        orientation="vertical"
                                                                        sx={{
                                                                            display: { xs: "none", sm: "block" },
                                                                            borderColor: "#a3a3a3",
                                                                        }}
                                                                    />
                                                                )}

                                                                <form onSubmit={formik.handleSubmit}>

                                                                    <Box className="d-flex flex-column w-100 p-3 h-100" maxWidth={!totalallocation?.data?.[selectedId]?.isNeedToSelectDate ? '400px' : 'fit-content'}>
                                                                        <Box className='w-100' flex={1} sx={{ maxWidth: '100%' }}>
                                                                            <FormControl
                                                                                fullWidth

                                                                                error={formik.touched.selectedVisitDate && Boolean(formik.errors.selectedVisitDate)}
                                                                            >
                                                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                                    <StaticDatePicker
                                                                                        // key={se.toString()}
                                                                                        value={
                                                                                            formik.values.selectedVisitDate
                                                                                                ? dayjs(formik.values.selectedVisitDate)
                                                                                                : null
                                                                                        }
                                                                                        onChange={(newValue) => {
                                                                                            formik.setFieldValue(
                                                                                                "selectedVisitDate",
                                                                                                newValue
                                                                                                    ? newValue.format("YYYY-MM-DD")
                                                                                                    : ""
                                                                                            );

                                                                                            const data2 = {
                                                                                                allocationId: totalallocation?.data?.[selectedId]?.allocations[activeStep]?.allocationId,
                                                                                                clientEntityId: totalallocation?.data?.[selectedId]?.allocations[activeStep]?.venueId.clientEntityId?.clientEntityId,
                                                                                                venueId: totalallocation?.data?.[selectedId]?.allocations[activeStep]?.venueId.venueId,
                                                                                                jobMonth: totalallocation?.data?.[selectedId]?.allocations[activeStep]?.jobMonth,
                                                                                                jobYear: totalallocation?.data?.[selectedId]?.allocations[activeStep]?.jobYear,
                                                                                                userId: userData?.userId,
                                                                                            };
                                                                                            (!isTransport) && newValue && allocationCriteria?.shouldBeDifferentVisitTimeFromPreviousAllocation && handleCallAnotherCriteria(data2, allocationCriteria?.isNeedToHideWeekend, allocationCriteria?.isNeedToHideNonWeekend)

                                                                                        }}
                                                                                        // referenceDate={
                                                                                        //     selectedmonth
                                                                                        //         ? dayjs(selectedmonth, "YYYY-MM")
                                                                                        //         : totalallocation?.data?.[selectedId]?.allocations[activeStep]?.jobYear && totalallocation?.data?.[selectedId]?.allocations[activeStep]?.jobMonth
                                                                                        //             ? dayjs(
                                                                                        //                 `${totalallocation?.data?.[selectedId]?.allocations[activeStep].jobYear}-${String(
                                                                                        //                     totalallocation?.data?.[selectedId]?.allocations[activeStep].jobMonth
                                                                                        //                 ).padStart(2, "0")}`,
                                                                                        //                 "YYYY-MM"
                                                                                        //             )
                                                                                        //             : dayjs()
                                                                                        // }

                                                                                        // minDate={
                                                                                        //    !totalallocation?.data?.[selectedId]?.isNeedToSelectDate && totalallocation?.data?.[selectedId]?.bundleMinDate
                                                                                        //         ? dayjs(selectedmonth, "YYYY-MM").date(totalallocation?.data?.[selectedId]?.bundleMinDate) // set day
                                                                                        //         : dayjs(selectedmonth, "YYYY-MM").startOf("month")
                                                                                        // }

                                                                                        referenceDate={
                                                                                            selectedmonth
                                                                                                ? dayjs(selectedmonth, "YYYY-MM")
                                                                                                : dayjs(`${totalallocation?.data?.[selectedId]?.allocations[activeStep]?.jobYear}-${String(totalallocation?.data?.[selectedId]?.allocations[activeStep]?.jobMonth).padStart(2, "0")}`, "YYYY-MM")

                                                                                        }
                                                                                        minDate={(() => {
                                                                                            const today = dayjs().startOf("day");

                                                                                            const isNeedDate = totalallocation?.data?.[selectedId]?.isNeedToSelectDate;
                                                                                            const bundleMin = totalallocation?.data?.[selectedId]?.bundleMinDate;
                                                                                            const month = totalallocation?.data?.[selectedId]?.month
                                                                                            const year = totalallocation?.data?.[selectedId]?.year

                                                                                            // Apply bundle logic only when condition is true
                                                                                            if ((!isNeedDate && isTransport) && bundleMin) {
                                                                                                const bundleMinDate = dayjs()
                                                                                                    .year(year)
                                                                                                    .month(month - 1)
                                                                                                    .date(bundleMin)
                                                                                                    .startOf("day");
                                                                                                // Ensure not less than today
                                                                                                return dayjs.max(today, bundleMinDate);
                                                                                            }

                                                                                            // Default: today
                                                                                            return today;
                                                                                        })()}

                                                                                        maxDate={
                                                                                            (!totalallocation?.data?.[selectedId]?.isNeedToSelectDate && isTransport) && totalallocation?.data?.[selectedId]?.bundleMaxDate
                                                                                                ? dayjs().month(totalallocation?.data?.[selectedId]?.month - 1).year(totalallocation?.data?.[selectedId]?.year).date(totalallocation?.data?.[selectedId]?.bundleMaxDate) // set day
                                                                                                : dayjs().month(totalallocation?.data?.[selectedId]?.month - 1).year(totalallocation?.data?.[selectedId]?.year).endOf("month")
                                                                                        }
                                                                                        shouldDisableDate={(date) =>
                                                                                            (totalallocation?.data?.[selectedId]?.isNeedToSelectDate || !isTransport) &&
                                                                                            (
                                                                                                // totalallocation[selectedId]?.allocations[activeStep]?.venueId?.locationType === 'region'
                                                                                                //     ?
                                                                                                //     shouldDisableDate(
                                                                                                //         date,
                                                                                                //         totalallocation[selectedId]?.allocations[activeStep]?.jobMonth,
                                                                                                //         totalallocation[selectedId]?.allocations[activeStep]?.jobYear,
                                                                                                //         allocationCriteria?.regionMinDate,
                                                                                                //         allocationCriteria?.regionMaxDate,
                                                                                                //         allocationCriteria?.regionVisitDaysInformation
                                                                                                //     )
                                                                                                //     :
                                                                                                shouldDisableDate(
                                                                                                    date,
                                                                                                    totalallocation?.data?.[selectedId]?.allocations[activeStep]?.jobMonth,
                                                                                                    totalallocation?.data?.[selectedId]?.allocations[activeStep]?.jobYear,
                                                                                                    totalallocation?.data?.[selectedId]?.allocations[activeStep]?.minDate,
                                                                                                    totalallocation?.data?.[selectedId]?.allocations[activeStep]?.maxDate,
                                                                                                    totalallocation?.data?.[selectedId]?.allocations[activeStep]?.visitDaysInformation
                                                                                                    // totalallocation?.data[selectedId]?.allocations[activeStep]?.minDate,
                                                                                                    // totalallocation?.data[selectedId]?.allocations[activeStep]?.maxDate,
                                                                                                    // totalallocation?.data[selectedId]?.allocations[activeStep]?.visitDaysInformation
                                                                                                )
                                                                                            )
                                                                                        }
                                                                                        sx={{
                                                                                            "& .MuiPickersCalendarHeader-switchViewButton":
                                                                                            {
                                                                                                // display: "none",
                                                                                            },
                                                                                            "& .MuiPickersArrowSwitcher-root": {
                                                                                                // display: "none",
                                                                                            },

                                                                                            "& .MuiPickersCalendarHeader-labelContainer":
                                                                                            {
                                                                                                pointerEvents: "none",
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                </LocalizationProvider>
                                                                                {formik.touched.selectedVisitDate && formik.errors.selectedVisitDate && (
                                                                                    <FormHelperText>{formik.errors.selectedVisitDate}</FormHelperText>
                                                                                )}
                                                                            </FormControl>
                                                                            {/* <ErrorMessage
                                                                                name="selectedVisitDate"
                                                                                component="div"
                                                                                className="error"
                                                                            /> */}
                                                                            <FormControl fullWidth sx={{ maxWidth: '100%' }}>
                                                                                <InputLabel
                                                                                    id="demo-simple-select-label"
                                                                                    shrink={false}
                                                                                >
                                                                                    {" "}
                                                                                    <span>
                                                                                        Visiting Time{" "}
                                                                                        <sup>
                                                                                            <i className="fa-solid fa-star-of-life star"></i>
                                                                                        </sup>
                                                                                    </span>
                                                                                </InputLabel>
                                                                                <Select
                                                                                    className='w-100'
                                                                                    sx={{ maxWidth: "100%", overflow: 'hidden' }}
                                                                                    labelId="demo-simple-select-label"
                                                                                    aria-placeholder="Select the Time"
                                                                                    value={formik.values.selectedVisitTime}
                                                                                    onChange={(e) =>
                                                                                        formik.setFieldValue(
                                                                                            "selectedVisitTime",
                                                                                            e.target.value
                                                                                        )
                                                                                    }
                                                                                    MenuProps={{
                                                                                        disablePortal: false, // Ensures dropdown is rendered inside the parent DOM
                                                                                    }}
                                                                                >
                                                                                    {filtervalue?.map((option: any, index: number) => (
                                                                                        <MenuItem
                                                                                            key={index}
                                                                                            value={option.visitTimeId}
                                                                                        >
                                                                                            {option.visitTimeInformation}
                                                                                        </MenuItem>
                                                                                    ))}
                                                                                </Select>
                                                                                {formik.touched.selectedVisitTime && formik.errors.selectedVisitTime && (
                                                                                    <FormHelperText className='text-danger'>{formik.errors.selectedVisitTime}</FormHelperText>
                                                                                )}
                                                                            </FormControl>

                                                                        </Box>
                                                                        <Button
                                                                            // type='submit'
                                                                            type={(allocationCriteria?.isNewBriefSetup && allocationCriteria?.isQuizRequired) ? "button" : 'submit'}
                                                                            className="button-primary mt-4"
                                                                            fullWidth
                                                                            // onClick={handleNext}
                                                                            onClick={async () => {
                                                                                if (!formik.values.selectedVisitDate || !formik.values.selectedVisitTime) {
                                                                                    await formik.setTouched({
                                                                                        selectedVisitDate: true,
                                                                                        selectedVisitTime: true,
                                                                                    });
                                                                                    toast.error('Please select both date and time')
                                                                                    return
                                                                                }
                                                                                if (allocationCriteria?.isNewBriefSetup && allocationCriteria?.isQuizRequired) {
                                                                                    await getBrief(
                                                                                        totalallocation?.data?.[selectedId]?.allocations[activeStep]?.venueId?.venueId,
                                                                                        totalallocation?.data?.[selectedId]?.allocations[activeStep]?.clientEntityId?.clientEntityId
                                                                                    );
                                                                                    if (!allocationCriteria?.isNewBriefSetup && allocationCriteria?.isQuizRequired) {
                                                                                        await handleOpenQuiz(
                                                                                            totalallocation?.data?.[selectedId]?.allocations[activeStep]?.clientEntityId?.clientEntityId,
                                                                                            totalallocation?.data?.[selectedId]?.allocations[activeStep]?.venueId?.venueId,
                                                                                            true
                                                                                        );
                                                                                    }
                                                                                    else {
                                                                                        // setOpenNewBriefDialog(true)
                                                                                        setOpenInfo(true)
                                                                                    }
                                                                                }
                                                                            }}
                                                                        >
                                                                            {/* {activeStep === steps.length - 1 ? 'Apply Task' : 'Next'} */}
                                                                            {allocationCriteria?.isQuizRequired ? "Take Quiz" : activeStep === steps.length - 1 ? 'Apply Task' : 'Next'}
                                                                        </Button>
                                                                        <Button onClick={() => { deleteinvtedallocation(totalallocation?.data?.[selectedId]?.invitedAllocationId) }} variant='outlined' className='button-danger-outlined mt-4' fullWidth>Reject</Button>

                                                                    </Box>
                                                                    <Dialog open={OpenNewBriefDialog && (totalallocation?.data?.[selectedId]?.isNeedToSelectDate || !isTransport)} className="full-dilaog d-flex flex-column" fullScreen>
                                                                        {/* <DialogActions className="justify-content-end w-100">
                                                                                <IconButton
                                                                                  className="ms-auto d-block m-0 p-0"
                                                                                  onClick={() => {
                                                                                    // handleBriefDialogClose();
                                                                                    setOpenNewBriefDialog(false)
                                                                                    setNewBrief(null)
                                                                                  }}
                                                                                >
                                                                                     <CancelOutlined className="fd-2" />
                                                                                </IconButton>
                                                                              </DialogActions> */}
                                                                        <DialogContent className="p-0" sx={{ flex: 1 }}>
                                                                            {newBrief?.data && (<ReadBrief isVewOnly={false} handleClose={() => setOpenNewBriefDialog(false)} newBrief={newBrief?.data} title={newBrief?.mainTitle} selecetedAllocation={totalallocation?.data?.[selectedId]?.allocations[activeStep]} setSelectedOptions={setSelectedOptions} setIsQuizSubmitted={setIsQuizSubmitted} selectedOptions={selectedOptions} QuizList={QuizList} handleOpenQuiz={handleOpenQuiz} submitform={formik.handleSubmit} />)}
                                                                        </DialogContent>
                                                                    </Dialog>

                                                                </form>

                                                            </Box>
                                                        </Box>
                                                    </React.Fragment>
                                                ) :
                                                (
                                                    <Box
                                                        className="w-100 d-flex align-items-start pt-5 justify-content-center"
                                                        height={"calc(100vh - 133px)"}
                                                    >
                                                        <Box>
                                                            {/* <Box
                                                                component="img"
                                                                className="mx-auto d-block"
                                                                src={sad}
                                                                height="128px"
                                                                alt="sad emoji"
                                                            /> */}
                                                            <Typography
                                                                className="text-center mt-3 fw-bold text-main"
                                                                variant="h4"
                                                            >
                                                                Your Form has been Submitted
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                )}
                                        </Box>

                                    </Box>
                                </>
                            )
                        }
                    </Box>
                </Box>
            ) : (
                <Box className='w-100 d-flex align-items-start pt-5 justify-content-center' height={'calc(100vh - 100px)'}>
                    <Box>
                        <Typography className="text-center mt-3 fw-bold text-main" variant='h4'>You don’t have any available invitations at the moment. If you got a notification about a task, it’s likely already been taken. task go quickly, so keep an eye out for new ones!</Typography>
                    </Box>
                </Box>
            )}
            {loading && <Loading />}
            <Dialog open={OpenDialog}>
                <DialogContent >
                    {selectedId !== null && (totalallocation?.data[selectedId] || newBrief) ? (
                        <>
                            <Box className='d-flex align-items-center justify-content-between mb-2'>
                                <Typography>{newBrief?.data[0]?.title}</Typography>
                                <IconButton className='ms-auto d-block' onClick={() => { handleDialogClose() }}><CancelOutlined className='fd-2' /></IconButton>
                            </Box>
                            <Box overflow='auto'
                                dangerouslySetInnerHTML={{
                                    __html: newBrief?.data[0]?.description || totalallocation?.data[selectedId]?.allocations[0]?.venueId?.venueDescription || totalallocation?.data[selectedId]?.allocations[activeStep]?.venueId?.venueDescription || "",
                                }}
                            />
                            <Button className='button-primary mx-auto py-2 px-4 d-block' onClick={() => { handleDialogClose() }}>Continue</Button>
                        </>
                    ) : (
                        <Typography variant='subtitle1'>No Data Found</Typography>
                    )}
                </DialogContent>
            </Dialog>

            <div className="full-dilaog">
                <Dialog open={OpenNewBriefReadDialog} className="full-dilaog d-flex flex-column" fullScreen>
                    <DialogContent className="p-0" sx={{ flex: 1 }}>
                        {newBrief?.data ? (<ReadBrief isVewOnly={true} handleClose={() => { setOpenNewBriefReadDialog(false) }} newBrief={newBrief?.data} title={newBrief?.mainTitle} selecetedAllocation={totalallocation?.data?.[selectedId]?.allocations[activeStep || 0]} setSelectedOptions={setSelectedOptions} setIsQuizSubmitted={setIsQuizSubmitted} selectedOptions={selectedOptions} QuizList={QuizList} handleOpenQuiz={handleOpenQuiz} submitform={formik.handleSubmit} />) : (<>Not FOund</>)}
                    </DialogContent>
                </Dialog>
            </div>

            <Dialog open={openInfo}>
                <DialogContent>
                    <Typography variant="h6">
                        Before applying for this task, please read the brief and complete a short knowledge check. Once you've passed, you won't need to take it again unless the brief changes.
                    </Typography>
                    <Box className='d-flex align-items-center gap-2 justify-content-center'>
                        <Button className="button-primary-outlined py-1 px-3" variant="outlined" onClick={() => { setOpenInfo(false) }}>Cancel</Button>
                        <Button className="button-primary py-1 px-3" onClick={() => { setOpenInfo(false); setOpenNewBriefDialog(true) }}>Continue</Button>
                    </Box>
                </DialogContent>
            </Dialog>
        </Box>
    )
}

export default Invitations
